// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Particle_Color_Ds = require("./Particle_Color_Ds.bs.js");

function toCss(colorStyle) {
  var color = Particle_Color_Ds.view(colorStyle);
  return CssJs.hsla(CssJs.deg(color.h), CssJs.pct(color.s), CssJs.pct(color.l), CssJs.pct(color.a));
}

exports.toCss = toCss;
/* CssJs Not a pure module */
